import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Ptuple(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Tuple Beginners Tutorials CodeExampler</title>
<meta name="description" content="Learn Free Python Tuple Beginners Tutorials CodeExampler Tuple is also a data structured in which we can store any type of value" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python tuple,python tuple assignment,python tuple append
,python tuple and list,python tuple,python tuple vs list,python list of tuples,python list to tuple" />
<link rel="canonical" href="https://www.codeexampler.com/python-tuple/"/>
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Tuple in CodeExampler</h1>


    <div className="first">
        <a href="/python-dictionary">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <p className="mt-4 para">1, This is also a data structure in which we can store any value<br/>
2, It is immutable means can’t be changed<br/>
3, A tuple looks just like a list, except you use parentheses instead of square brackets<br/>
</p>    
<h2 className="mt-4 mh2">python tuple Syntax:</h2>




       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">()</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div> 

<h2 className="mt-4 mh2">python tuple vs list</h2>




<h2 className='headings'>Difference between tuple and list</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">Vowels_l</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">e</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">i</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">o</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">u</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">]</span>
            {"\n"}
                <span className="qwerty-2">type</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">Vowels_l</span>
                <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-4">Vowels_l</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">e</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">i</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">o</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">u</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-2">type</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">Vowels_l</span>
                <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
       <h5 className='headings'>Output </h5>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-1">&#60;</span>
                <span className="qwerty-7">class </span>
                <span className="qwerty-1">'</span>
                <span className="qwerty-3">list</span>
                <span className="qwerty-1">'</span>
                <span className="qwerty-1">&#62;</span>
            {"\n"}
                <span className="qwerty-1">&#60;</span>
                <span className="qwerty-7">class </span>
                <span className="qwerty-1">'</span>
                <span className="qwerty-3">tuple</span>
                <span className="qwerty-1">'</span>
                <span className="qwerty-1">&#62;</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>   

<h2 className="mt-4 mh2">Python Creates an empty tuple and <a style={{textDecoration: 'none'}} target="_blank" href="https://www.codeexampler.com/python-dictionary">Learn Python Dictionary tutorials for beginners Free</a> </h2>


<h2 className='headings'>Python Empty tuple Types Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">40</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Code Exampler</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">40</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-2">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-2">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-2">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#60;</span>
                 <span className="qwerty-7">class </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">int</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">&#62;</span>
             {"\n"}
                 <span className="qwerty-1">&#60;</span>
                 <span className="qwerty-7">class </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">str</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">&#62;</span>
             {"\n"}
                 <span className="qwerty-1">&#60;</span>
                 <span className="qwerty-7">class </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">tuple</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">&#62;</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  


<h3 className="mt-4 mh3">How you check this is a tuple or not:</h3>




<h2 className='headings'>Python Tuple Types Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-3">Print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">tup1</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-5">int</span>
             {"\n"}
                 <span className="qwerty-3">Print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">tup2</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-5">string</span>
             {"\n"}
                 <span className="qwerty-3">Print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">tup3</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-5">tuple</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  

<h2 className="mt-4 mh2">python Tuple Example:</h2>


<h2 className='headings'>Q-Write a Program to Check City Name in Python Tuple Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">City</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Delhi</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Meerut</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Lucknow</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">City</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">Delhi</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">Meerut</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">Lucknow</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>      


<h2 className="mt-4 mh2">Tuple sequence argument:</h2>



<h2 className='headings'>Q-Write a Program to distinguish Full Name in Sequence Python tuple Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">tup</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">tuple</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">A</span>
                 <span className="qwerty-10">M</span>
                 <span className="qwerty-10">E</span>
                 <span className="qwerty-10">R</span>
                 <span className="qwerty-10">I</span>
                 <span className="qwerty-10">C</span>
                 <span className="qwerty-10">A</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">tup</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">A</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">M</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">E</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">R</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">I</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">C</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">A</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>        


<h2 className="mt-4 mh2">Tuple list operator:</h2>

        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">I</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">N</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">D</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">I</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">A</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-8">D</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  


<h2 className="mt-4 mh2">Slice operator In Python list:</h2>


<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">I</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">N</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">D</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">I</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">A</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-2">4</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">N</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">D</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">I</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 


<h2 className="mt-4 mh2">Tuple unpacking in Python list:</h2>




<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">City</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ayodhya</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Varanasi</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Mathura</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-7">c1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">c2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">c3</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">City</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">c1</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">c2</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">c3</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-8">Ayodhya</span>
             {"\n"}
                 <span className="qwerty-8">Varanasi</span>
             {"\n"}
                 <span className="qwerty-8">Mathura</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 


<h2 className="mt-4 mh2">Use List Inside Python Tuple:</h2>


<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">30</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">200</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">400</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-2">0</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-2">3</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-8">10</span>
             {"\n"}
                 <span className="qwerty-8">20</span>
             {"\n"}
                 <span className="qwerty-8">30</span>
             {"\n"}
             <span className="qwerty-1">(</span>
                 <span className="qwerty-8">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">200</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">400</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>   


<h2 className="mt-4 mh2">Python tuple Function</h2>
<h3 className="mt-4 mh3">1,max <br/>2, min<br/> 3,sum<br/> 4,count<br/> 5,len <br/>6,count
</h3>



<h2 className='headings'>Python tuple Function Example:</h2>
<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">30</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">40</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">26</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">max</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">min</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">len</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">sum</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-8">40</span>
             {"\n"}
                 <span className="qwerty-8">10</span>
             {"\n"}
                 <span className="qwerty-8">5</span>
             {"\n"}
                 <span className="qwerty-8">126</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 

<h2 className="mt-4 mh2">Create Tuple Using Range function:</h2>
<h3 className="mt-4 mh3">Create a tuple list:</h3>


<h2 className='headings'>Slice Operator Check Range in Python list Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">num</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">tuple</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">6</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">num</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">5</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  




<h2 className='headings'>Slice Operator in Python list Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">num</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">list</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">5</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">num</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-8">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">5</span>
                 <span className="qwerty-1">]</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  

<h2 className="mt-4 mh2">Convert tuple to string:</h2>


        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">str</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">5</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">type</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#60;</span>
                 <span className="qwerty-3">class </span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-7">str</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">&#62;</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>     


<h2 className="mt-4 mh2">Return Python tuple by using a function:</h2>
<p className="mt-4 para">This function can return more than one value but in the form of a tuple.</p>


<h2 className='headings'>Q-Return Function in a Python tuple Example?</h2>
<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-2">tup</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-7">    add</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-7">    mult</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-6">    return</span>
                 <span className="qwerty-7"> add</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">mult</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">tup</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-5">50</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-5">60</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-3">110</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-3">3000</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  


<h2 className="mt-4 mh2">Create Python tuple Zip</h2>
<h3 className="mt-4 mh3">Use zip in a tuple</h3>
<p className="mt-4 para">zip used to combine list and string</p>



<h2 className='headings'>Q-Write a Program to zip in a Python tuple Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">str </span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">abc</span>
                 <span className="qwerty-6">'</span>
             {"\n"}
                 <span className="qwerty-7">li</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">30</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">zip</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">str</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">li</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">tuple</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">10</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">b</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">20</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">c</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">30</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-dictionary">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Ptuple;